export default __webpack_public_path__ + "static/media/topic_design.b796c22b.png";